'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (config, hideEmptyRowItems) {
    var emptySeriesIndexes = getEmptySeriesIndexes(config.series);

    var _getFirstLastValueInd = getFirstLastValueIndexes(config.series),
        firstValueIndex = _getFirstLastValueInd.firstValueIndex,
        lastValueIndex = _getFirstLastValueInd.lastValueIndex;

    return emptySeriesIndexes.length && config.xAxis && config.series ? _extends({}, config, getTrimmedXAxisObject(config.xAxis, emptySeriesIndexes, firstValueIndex, lastValueIndex, hideEmptyRowItems), getTrimmedSeriesObject(config.series, emptySeriesIndexes, firstValueIndex, lastValueIndex, hideEmptyRowItems)) : config;
};

var _arrayContains = require('d2-utilizr/lib/arrayContains');

var _arrayContains2 = _interopRequireDefault(_arrayContains);

var _arrayUnique = require('d2-utilizr/lib/arrayUnique');

var _arrayUnique2 = _interopRequireDefault(_arrayUnique);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function arrayCleanUndefined(array) {
    return array.filter(function (item) {
        return item !== undefined;
    });
}

function arrayNullsOnly(array) {
    return (0, _arrayContains2.default)(array, null) && (0, _arrayUnique2.default)(array).length === 1;
}

function getEmptySeriesIndexes(series) {
    var emptyIndexes = [];
    var seriesValues = void 0;

    series[0].data.forEach(function (value, index) {
        seriesValues = [];

        series.forEach(function (seriesObj) {
            seriesValues.push(seriesObj.data[index]);
        });

        if (arrayNullsOnly(seriesValues)) {
            emptyIndexes.push(index);
        }
    });

    return emptyIndexes;
}

function getFirstLastValueIndexes(series) {
    var firstValueIndex = undefined;
    var lastValueIndex = 0;
    var data = void 0;
    var i = void 0;

    series.forEach(function (seriesObj) {
        // make a copy of the array so we can reverse it
        // without affecting the original
        data = seriesObj.data.slice();

        i = data.findIndex(function (value) {
            return value != undefined;
        });

        if (i > -1) {
            firstValueIndex = firstValueIndex !== undefined ? Math.min(firstValueIndex, i) : i;
        }

        i = data.reverse().findIndex(function (value) {
            return value != undefined;
        });

        if (i > -1) {
            lastValueIndex = Math.max(lastValueIndex, data.length - 1 - i);
        }
    });

    return { firstValueIndex: firstValueIndex, lastValueIndex: lastValueIndex };
}

function cleanData(data, emptySeriesIndexes, firstValueIndex, lastValueIndex, hideEmptyRowItems) {
    var cleanedData = void 0;

    switch (hideEmptyRowItems) {
        case 'ALL':
            cleanedData = arrayCleanUndefined(data.map(function (value, index) {
                return (0, _arrayContains2.default)(emptySeriesIndexes, index) ? undefined : value;
            }));
            break;
        case 'BEFORE_FIRST':
            cleanedData = data.slice(firstValueIndex);
            break;
        case 'AFTER_LAST':
            cleanedData = data.slice(0, lastValueIndex + 1);
            break;
        case 'BEFORE_FIRST_AFTER_LAST':
            cleanedData = data.slice(firstValueIndex, lastValueIndex + 1);
            break;
        default:
            cleanedData = data;
    }

    return cleanedData;
}

function getTrimmedXAxisObject(xAxis, emptySeriesIndexes, firstValueIndex, lastValueIndex, hideEmptyRowItems) {
    return {
        xAxis: _extends({}, xAxis, {
            categories: cleanData(xAxis.categories, emptySeriesIndexes, firstValueIndex, lastValueIndex, hideEmptyRowItems)
        })
    };
}

function getTrimmedSeriesObject(series, emptySeriesIndexes, firstValueIndex, lastValueIndex, hideEmptyRowItems) {
    return {
        series: series.map(function (seriesObj) {
            return _extends({}, seriesObj, {
                data: cleanData(seriesObj.data, emptySeriesIndexes, firstValueIndex, lastValueIndex, hideEmptyRowItems)
            });
        })
    };
}
//# sourceMappingURL=getTrimmedConfig.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/getTrimmedConfig.js
 ** module id = 196
 ** module chunks = 0 1
 **/